import { PintraRedirect } from './PintraRedirect';
import 'core-js/fn/promise/finally';

(window as any).wpo365 = (window as any).wpo365 || {};
(window as any).wpo365.pintraRedirect = new PintraRedirect();
